import { render, staticRenderFns } from "./PicturesSearch.vue?vue&type=template&id=1522452b&"
import script from "./PicturesSearch.vue?vue&type=script&lang=js&"
export * from "./PicturesSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports